import { render, staticRenderFns } from "./AssignInChargeInvestigators.vue?vue&type=template&id=534a7a1e&scoped=true"
import script from "./AssignInChargeInvestigators.vue?vue&type=script&lang=js"
export * from "./AssignInChargeInvestigators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534a7a1e",
  null
  
)

export default component.exports